// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type { PagedAsyncIterableIterator } from "@azure/core-paging";
import type {
  ReachabilityAnalysisIntent,
  ReachabilityAnalysisIntentsListOptionalParams,
  ReachabilityAnalysisIntentsGetOptionalParams,
  ReachabilityAnalysisIntentsGetResponse,
  ReachabilityAnalysisIntentsCreateOptionalParams,
  ReachabilityAnalysisIntentsCreateResponse,
  ReachabilityAnalysisIntentsDeleteOptionalParams,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a ReachabilityAnalysisIntents. */
export interface ReachabilityAnalysisIntents {
  /**
   * Gets list of Reachability Analysis Intents .
   * @param resourceGroupName The name of the resource group.
   * @param networkManagerName The name of the network manager.
   * @param workspaceName Workspace name.
   * @param options The options parameters.
   */
  list(
    resourceGroupName: string,
    networkManagerName: string,
    workspaceName: string,
    options?: ReachabilityAnalysisIntentsListOptionalParams,
  ): PagedAsyncIterableIterator<ReachabilityAnalysisIntent>;
  /**
   * Get the Reachability Analysis Intent.
   * @param resourceGroupName The name of the resource group.
   * @param networkManagerName The name of the network manager.
   * @param workspaceName Workspace name.
   * @param reachabilityAnalysisIntentName Reachability Analysis Intent name.
   * @param options The options parameters.
   */
  get(
    resourceGroupName: string,
    networkManagerName: string,
    workspaceName: string,
    reachabilityAnalysisIntentName: string,
    options?: ReachabilityAnalysisIntentsGetOptionalParams,
  ): Promise<ReachabilityAnalysisIntentsGetResponse>;
  /**
   * Creates Reachability Analysis Intent.
   * @param resourceGroupName The name of the resource group.
   * @param networkManagerName The name of the network manager.
   * @param workspaceName Workspace name.
   * @param reachabilityAnalysisIntentName Reachability Analysis Intent name.
   * @param body Reachability Analysis Intent object to create/update.
   * @param options The options parameters.
   */
  create(
    resourceGroupName: string,
    networkManagerName: string,
    workspaceName: string,
    reachabilityAnalysisIntentName: string,
    body: ReachabilityAnalysisIntent,
    options?: ReachabilityAnalysisIntentsCreateOptionalParams,
  ): Promise<ReachabilityAnalysisIntentsCreateResponse>;
  /**
   * Deletes Reachability Analysis Intent.
   * @param resourceGroupName The name of the resource group.
   * @param networkManagerName The name of the network manager.
   * @param workspaceName Workspace name.
   * @param reachabilityAnalysisIntentName Reachability Analysis Intent name.
   * @param options The options parameters.
   */
  delete(
    resourceGroupName: string,
    networkManagerName: string,
    workspaceName: string,
    reachabilityAnalysisIntentName: string,
    options?: ReachabilityAnalysisIntentsDeleteOptionalParams,
  ): Promise<void>;
}
